<template>
  <div class="invitedUserSuccess">
    <div class="icon_box">
      <van-icon name="passed" size="60" color="#07c160" />
    </div>
    <p class="text">提交成功!</p>
  </div>
</template>

<script>

import { Icon } from 'vant'

export default {
  components: {
    vanIcon: Icon
  }
}
</script>

<style lang="scss" scoped>
.invitedUserSuccess {
  width: 100%;
  .icon_box {
    margin-bottom: 20px;
    padding-top: 40px;
    text-align: center;
  }
  .text {
    text-align: center;
    font-size: 24px;
  }
}
</style>